var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", { staticClass: "plaintext-sm" }, [
      _vm._v(_vm._s(_vm.hi3PastYear.yearOfService)),
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "plaintext-sm" }, [
      _vm._v(_vm._s(_vm.hi3PastYear.age)),
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "plaintext-sm" }, [
      _vm._v(_vm._s(_vm.hi3PastYear.calendarYear)),
    ]),
    _vm._v(" "),
    _c("td", [
      _c("div", { staticClass: "form-group" }, [
        _c(
          "select",
          {
            staticClass: "form-control input-sm",
            domProps: { value: _vm.hi3PastYear.yearOfServiceRank },
            on: {
              change: function ($event) {
                return _vm.onRankChange($event.target.value)
              },
            },
          },
          _vm._l(_vm.hi3PastYear.overrideRanks, function (rank) {
            return _c("option", { key: rank, domProps: { value: rank } }, [
              _vm._v(_vm._s(rank)),
            ])
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }